import { ValueDisplayValue } from "@mcleod/core";
import { ComponentPropDefinitionUtil, ComponentPropDefinitions, ComponentProps } from "../../base/ComponentProps";

export interface RadioOptionProps extends ComponentProps {
    valueDisplayValue: ValueDisplayValue;
}

let radioOptionPropsDefs: ComponentPropDefinitions;

export abstract class RadioOptionPropDefinitions {
    public static getDefinitions(): ComponentPropDefinitions {
        if (radioOptionPropsDefs == null) {
            radioOptionPropsDefs = {
                ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions(),
                ...ComponentPropDefinitionUtil.getDataBoundPropertyDefinitions(),
            };
            ComponentPropDefinitionUtil.populateComponentPropNames(radioOptionPropsDefs);
        }
        return radioOptionPropsDefs;
    }
}
